
import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { ToastProvider } from './components/Common/Toast/ToastProvider';
import Layout from './components/Layout';
import { setupAxiosInterceptors } from './helpers/axiosSetup';
import { registerPushWorkerIfGranted } from './helpers/push/firebaseMessaging';
import './index.scss';
import store from './store';
import { ThemeModeProvider } from './theme/ThemeModeProvider';

// Wire up the 401 → logout redirect before any components mount.
setupAxiosInterceptors(store);

// Chrome notifications' service worker: production builds only, and only for a browser that has
// already granted permission. The first grant registers it from usePushNotifications instead.
registerPushWorkerIfGranted();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <Provider store={store}>
      <ThemeModeProvider>
        <ToastProvider>
          <Layout />
        </ToastProvider>
      </ThemeModeProvider>
    </Provider>
  </React.StrictMode>
);
